module.exports = __webpack_public_path__ + "static/ausopen-01-f79d66d5f964c9c45b092c729781534d.png";